import React from "react";
import { Modal } from "../../SharedComponents";
import { ModalNames } from "../../../Constants/modalNames";
import { useModal } from "../../../Store/modules/modal/modal";
import { Div, Icon, Text } from "../../Kit";
import { useLanguage } from "../../../Store/modules/language";
import { DocumentDownload } from "iconsax-react";

export const PreviewGeneratedImageModal: React.FC = () => {
  const { modalProps } = useModal();
  const { direction } = useLanguage();
  const { url } = modalProps || {};

  const download = (url: string) => {
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    link.download = "image.png";
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  //.pdf, .jpeg, .jpg, .png, .csv, .xls, .xlsx, .ppt, .pptx,.doc,.docx,.svg,.mp3 ,.ogg ,.aac, .wav

  const isOfficeProduct =
    url?.includes(".csv") ||
    url?.includes(".xls") ||
    url?.includes(".xlsx") ||
    url?.includes(".ppt") ||
    url?.includes(".pptx") ||
    url?.includes(".docx") ||
    url?.includes(".doc");

  const isImage =
    url?.includes(".jpeg") ||
    url?.includes(".jpg") ||
    url?.includes(".svg") ||
    url?.includes(".png");

  return (
    <Modal
      modalName={ModalNames.PreviewGeneratedImage}
      modalClassName="lg:w-auto xs:h-auto xs:w-[90%] rounded-[5px] hide-scrollbar"
      ignorePadding
    >
      <div className="flex justify-center items-center max-h-[90vh] max-w-full">
        {isImage ? (
          <img
            src={url}
            alt="preview-image"
            className="rounded-[5px] relative max-h-[90vh] max-w-full object-contain"
          />
        ) : null}

        {url?.includes(".pdf") ? (
          <iframe
            src={url}
            title="pdf"
            className="rounded-[5px] xs:h-[90vh] xs:w-full md:w-[500px] md:h-[700px] relative max-h-[90vh] max-w-full object-contain"
          />
        ) : null}
        {isOfficeProduct ? (
          <iframe
            src={`https://view.officeapps.live.com/op/embed.aspx?src=${url}`}
            title="office-product"
            className="rounded-[5px] xs:h-[90vh] xs:w-full md:w-[500px] md:h-[700px] relative max-h-[90vh] max-w-full object-contain"
          />
        ) : null}
        {isImage ? (
          <Div
            className="flex justify-center pointer absolute bottom-[10px] py-[10px] backdrop-blur-[3px] w-auto px-[20px] rounded-[5px]"
            dir={direction}
            bg="bluredBackground"
            onClick={() => download(url)}
          >
            <Icon Component={DocumentDownload} color="white" size={20} />
            <Text elementType="span" className="text-sm mx-1" color="white">
              download
            </Text>
          </Div>
        ) : null}
      </div>
    </Modal>
  );
};
